import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import '../App.css';

function BestNashaMuktiKendraPatna() {
  useEffect(() => {
    const handleScroll = () => {
      document.querySelectorAll('.animate-on-scroll').forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight - 150) {
          el.classList.add('animate');
        }
      });
    };
    setTimeout(handleScroll, 100);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <SEO
        title="Best Nasha Mukti Kendra in Patna | निहांश फाउंडेशन"
        description="Best Nasha Mukti Kendra in Patna — निहांश फाउंडेशन: अनुभवी टीम, 24×7 केयर, सुरक्षित रिहैब। शराब व ड्रग्स की लत से मुक्ति। +91 6202410010"
        path="/best-nasha-mukti-kendra-in-patna"
      />
      <section
        className="page-hero about-hero"
        style={{
          backgroundImage: 'url(/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-07.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
        }}
      >
        <div className="page-hero-background">
          <div className="page-hero-overlay"></div>
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">Best Nasha Mukti Kendra in Patna</h1>
          <p className="page-hero-subtitle">निहांश फाउंडेशन — गुणवत्ता, देखभाल और नतीजों पर फोकस</p>
        </div>
      </section>

      <section className="about">
        <div className="container">
          <div className="local-seo-page-content animate-on-scroll">
            <p className="local-seo-lead">
              <strong>Best Nasha Mukti Kendra in Patna</strong> चुनते समय सिर्फ कीमत नहीं — मेडिकल सुविधा, काउंसलर की योग्यता, 24×7 मॉनिटरिंग और पारिवारिक सहयोग जैसी बातें देखें। निहांश फाउंडेशन इन्हीं मानकों पर खरा उतरता है।
            </p>

            <h2 className="local-seo-h2">सही केंद्र की पहचान</h2>
            <ul className="local-seo-list">
              <li>क्वालिफाइड डॉक्टर व मनोवैज्ञानिक की उपलब्धता</li>
              <li>Detox के दौरान सुरक्षित निगरानी — खासकर इंजेक्शन व स्मैक जैसे गंभीर नशों में</li>
              <li>हर मरीज के लिए व्यक्तिगत ट्रीटमेंट प्लान</li>
              <li>छुट्टी के बाद फॉलो-अप और रिलैप्स रोकथाम</li>
            </ul>

            <h2 className="local-seo-h2">निहांश फाउंडेशन क्यों?</h2>
            <p>
              पटना में हम <strong>nasha mukti kendra in Patna</strong> के रूप में पारदर्शी और मानवीय देखभाल देते हैं। परिवार को शिक्षित करना, नशा छोड़ने वाले को बिना भेदभाव के सहारा देना — हमारी प्राथमिकता है।
            </p>

            <p>
              सामान्य जानकारी के लिए <Link to="/nasha-mukti-kendra-in-patna">Nasha Mukti Kendra in Patna</Link> पेज देखें; विस्तार से लेख <Link to="/blog">ब्लॉग</Link> पर उपलब्ध हैं।
            </p>

            <div className="local-seo-cta">
              <a href="tel:+916202410010" className="cta-button primary">📞 +91 6202410010</a>
              <Link to="/contact" className="cta-button secondary">संपर्क व पता</Link>
              <Link to="/about" className="cta-button secondary">संस्था के बारे में</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BestNashaMuktiKendraPatna;
